<template>
    <a-entity>

        <a-yoga-layout
            width-auto="1" height-auto="1"
            padding="0.02"
            flex-wrap="wrap"
            flex-direction="column"
            align-items="center"
            justify-content="center"

            class="clickable"

            geometry="primitive: rounded-plane;" material="color: #001034;"
            push-mesh-backwards="distance: 0.02"
        >
            <a-yoga-layout
                width-auto="1" height-auto="1"
                padding="0"
                flex-wrap="wrap"
                flex-direction="row"
                align-items="center"
                justify-content="space-between"
                yoga-layout-item="margin: 0.01; marginEdge: vertical"

                geometry="primitive: plane;" material="visible: false"
            >
              <a-image src="/aframe-assets/icons/home.png"
                       width="0.05" height="0.05"
                       class="clickable"
                       yoga-layout-item="margin: 0.02; marginEdge: horizontal"
                       ui-icon
                       play-sound="audio: #audio-bop; events: click"
                       @click="setFirstPage()"
              ></a-image>
              <a-image id="navigationIcon" src="/aframe-assets/icons/menu.png"
                       width="0.05" height="0.05"
                       class="clickable"
                       yoga-layout-item="margin: 0.02; marginEdge: horizontal"
                       ui-icon
                       play-sound="audio: #audio-bop; events: click"
                       toggle-modal="#navigationPanel"
              ></a-image>
              <a-image id="exitIcon" ref="exitIcon" src="/aframe-assets/icons/logout.png"
                       width="0.05" height="0.05"
                       class="clickable"
                       yoga-layout-item="margin: 0.02; marginEdge: horizontal"
                       ui-icon
                       play-sound="audio: #audio-bop; events: click"
                       exit-vr-button
              ></a-image>
                <!--                <a-image id="debugIcon" ref="debugIcon" src="/aframe-assets/icons/debug.png"-->
                <!--                         width="0.05" height="0.05"-->
                <!--                         class="clickable"-->
                <!--                         yoga-layout-item="margin: 0.02; marginEdge: horizontal"-->
                <!--                         ui-icon-->
                <!--                         play-sound="audio: #audio-bop; events: click"-->
                <!--                         toggle-modal="#debugPanel"-->
                <!--                ></a-image>-->

            </a-yoga-layout>
            <a-yoga-layout
                width-auto="1" height-auto="1"
                padding="0"
                flex-wrap="nowrap"
                flex-direction="row"
                align-items="center"
                justify-content="space-between"
                yoga-layout-item="margin: 0.02; marginEdge: top"

                geometry="primitive: plane;" material="visible: false"
            >
                <a-image src="/aframe-assets/images/siemens-icon.png" width="0.02" height="0.02"></a-image>
              <a-entity
                  html-dev="autoEnable: true"
                  geometry="primitive: plane; width:0.1; height: 0" material="visible: false; transparent: true"
                  yoga-layout-item="margin: 0.01; marginEdge: left; padding: 0"
              >
                <div class="vr">
                  <p class="small">
                    {{ title }}<br>
                    {{ this.$parent.settings ? this.$parent.settings.copyright : '' }}
                  </p>
                </div>
              </a-entity>
<!--                <a-entity-->
<!--                    html="ppu: 1000; width: 0.2; height: 0.3; autoWidth: true; autoHeight: true"-->
<!--                    geometry="primitive: plane; width:0.2; height: 0" material="visible: false; transparent: true"-->
<!--                    yoga-layout-item="margin: 0.01; marginEdge: left; padding: 0"-->
<!--                >-->
<!--                    <div class="vr vr-distance-0-5 vr-width-auto vr-height-auto">-->
<!--                        <p>-->
<!--                            {{ title }}<br>-->
<!--                            {{ this.$parent.settings ? this.$parent.settings.copyright : '' }}-->
<!--                        </p>-->
<!--                    </div>-->
<!--                </a-entity>-->
            </a-yoga-layout>
            <a-yoga-layout
                width-auto="1" height-auto="1"
                padding="0"
                flex-wrap="nowrap"
                flex-direction="row"
                align-items="center"
                justify-content="space-between"
                yoga-layout-item="margin: 0.02; marginEdge: top"

                geometry="primitive: plane;" material="visible: false"
            >
              <a-image
                  v-for="site in sites" v-bind:key="'i' + site.id" 
                        :src="'/img/locale/'+site.locale.lang+'.png'"
                        width="0.155" height="0.07"
                       class="clickable"
                       yoga-layout-item="margin: 0.01; marginEdge: left; padding: 0"
                       ui-icon
                       play-sound="audio: #audio-bop; events: click"
                       @click="setSite(site)"
              ></a-image>
<!--              <a-entity-->
<!--                  html-dev="autoEnable: true"-->
<!--                  v-for="site in sites" v-bind:key="site.id" -->
<!--                  yoga-layout-item="margin: 0.01; marginEdge: left; padding: 0"-->
<!--                  class="clickable" -->
<!--                  ui-icon-->
<!--                  @click="setSite(site)"-->
<!--                  geometry="primitive: plane; width:.1; height: .01" -->
<!--                  material="visible: false; transparent: true"-->
<!--              >-->
<!--                <div class="vr"><span class="link" v-html="site.locale.lang"></span></div>-->
<!--              </a-entity>-->
                            
<!--                <a-entity-->
<!--                    v-for="site in sites" v-bind:key="site.id"-->
<!--                    html="ppu: 1000; autoWidth: true; autoHeight: true"-->
<!--                    geometry="primitive: plane; width:0; height: 0" material="visible: false; transparent: true"-->
<!--                    yoga-layout-item="margin: 0.01; marginEdge: left; padding: 0"-->
<!--                    class="clickable" ui-icon-->
<!--                    @click="setSite(site)"-->
<!--                    play-sound="audio: #audio-bop; events: click"-->
<!--                >-->
<!--                    <div class="vr vr-distance-0-5 vr-width-auto vr-height-auto">-->
<!--                        <span v-if="currentLocale === site.locale.id" class="vr-link-selected">{{ site.locale.nativeName }}</span>-->
<!--                        <span v-if="currentLocale !== site.locale.id">{{ site.locale.nativeName }}</span>-->
<!--                    </div>-->
<!--                </a-entity>-->
            </a-yoga-layout>
        </a-yoga-layout>
    </a-entity>
</template>

<script>
import {locales} from "./i18n";

export default {
    name: "HomePanel",
    props: ['title', 'pages', 'currentPage', 'sites', 'vrMode', 'isVrMode'],
    computed: {
        currentLocale() {
            return this.$i18n.locale;
        },
        locales() {
            return locales;
        },
    },
    watch: {
        isVrMode: function (v) {
            //this.$refs.exitIcon.setAttribute('advanced-visible', v);
        }
    },
    mounted: function () {
        //this.$refs.exitIcon.setAttribute('advanced-visible', false);
    },
    methods: {
        setFirstPage() {
            this.$emit('select-page', this.pages[0]);
            document.querySelector('#navigationPanel').setAttribute('advanced-visible', false);
        },
        setSite(site) {
            this.$emit('select-site', site);
        },
    }
}
</script>

<style scoped>

</style>